import { shopCurrencyDigits as currencyDigits, shopCurrencySymbol } from "@stackje/site-builder/shop-money";
export { currencyDigits };

/** Currency precision comes from Intl; entry is converted with decimal strings, never floating-point multiplication. */
export function moneyInput(amount: number | null, currency: string): string {
  if (amount === null) return "";
  const digits = currencyDigits(currency);
  const raw = String(amount).padStart(digits + 1, "0");
  return digits ? `${raw.slice(0, -digits)}.${raw.slice(-digits)}` : raw;
}
export function parseMoney(input: string, currency: string, language = "en"): number | null {
  const parts = new Intl.NumberFormat(language).formatToParts(1.1);
  const decimal = parts.find((part) => part.type === "decimal")?.value ?? ".";
  let value = input.trim().replace(decimal, ".");
  const digitsFormatter = new Intl.NumberFormat(language, { useGrouping: false });
  for (let digit = 0; digit < 10; digit++) value = value.split(digitsFormatter.format(digit)).join(String(digit));
  if (!/^\d+(?:\.\d+)?$/.test(value)) return null;
  const [whole, fraction = ""] = value.split(".");
  const digits = currencyDigits(currency);
  if (fraction.length > digits) return null;
  const amount = Number(`${whole}${fraction.padEnd(digits, "0")}`);
  return Number.isSafeInteger(amount) && amount >= 0 ? amount : null;
}
/** The short symbol people write before a price ("RM", "$", "€"), for the currency in the language of the page. */
export function currencySymbol(currency: string, language = "en"): string {
  return shopCurrencySymbol(currency, language);
}
export { money as formatMoney } from "@stackje/site-builder";
